import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Document } from '../../models/document.model';
import { LocaleObserver } from '../../observers/locale.observer';
import { DocumentService } from '../../services/document.service';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {

  public onlyColumnOne = true
  public onlyColumnTwo = false

  private id: number | null;
  private slug: string | null;

  public document: Document

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentService,
    private localeObserver: LocaleObserver,
  ) {
    /* DO NOT DELETE */
    new Document();
    /* DO NOT DELETE END */

    this.route.paramMap.subscribe(
      (params) => {
        if (params.get('id')) {
          this.id = parseInt(params.get('id') || '0')
        }
        if (params.get('slug')) {
          this.slug = params.get('slug')
        }

        this.load()
      }
    )

    this.localeObserver.localeChangedObserver.subscribe(
      (locale) => {
        this.load()
      }
    )
  }

  ngOnInit(): void {
  }

  toggleColumns() {
    this.onlyColumnOne = !this.onlyColumnOne
    this.onlyColumnTwo = !this.onlyColumnTwo
  }

  showOnlyColumnOne() {
    this.onlyColumnOne = true
    this.onlyColumnTwo = false
  }

  showOnlyColumnTwo() {
    this.onlyColumnOne = false
    this.onlyColumnTwo = true
  }

  private load() {
    if (this.id && this.slug) {

      if (this.localeObserver.currentLocale !== 'DE') {
        this.showOnlyColumnTwo()
      } else {
        this.showOnlyColumnOne()
      }

      this.documentService.document(this.id, this.localeObserver.currentLocale).subscribe(
        (doc) => this.document = doc
      )
    }
  }

}
